import React, { Component } from 'react';
import './bounce.css';

export default class BounceSpace extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isShowBounce: this.props.params.isShowBounce ? { display: 'block' } : { display: 'none' },
            classNameStr: "public-bounce-space " + (this.props.params.className ? this.props.params.className : ""),
        };
    }
    componentDidMount() {
    }
    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            isShowBounce: nextProps.params.isShowBounce ? { display: 'block' } : { display: 'none' },
            classNameStr: "public-bounce-space " + (nextProps.params.className ? nextProps.params.className : ""),
        });
    }
    render() {
        return (
            <div className='bounce-space-content' style={this.state.isShowBounce}>
                <div className={this.state.classNameStr} ></div>
            </div>
        );
    }

}

type Props = {
    params: {
        isShowBounce: boolean,
        className: string,
    }
}
type State = {
    isShowBounce: { [key: string]: any };
    classNameStr: string;
}